var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticStyle:{"height":"60px"},style:({
      width: _vm.isCollapse ? _vm.closeWidth : _vm.openWidth,
    })},[_c('div',{staticStyle:{"position":"fixed","width":"200px","background-color":"#282637","z-index":"10"},style:({
        width: _vm.isCollapse ? _vm.closeWidth : _vm.openWidth,
      })},[_c('div',{staticClass:"logoBox"},[_c('img',{staticClass:"logoImg",style:({
            width: _vm.logoWidth,
          }),attrs:{"src":require("../../assets/logo.png"),"alt":""}}),(!_vm.isCollapse)?_c('span',{staticClass:"title",staticStyle:{"display":"block","line-height":"120%","margin-left":"15px"}},[_vm._v(" 备考通平台")]):_vm._e()])])]),_c('el-menu',{attrs:{"background-color":"#181626","text-color":"#fff","default-active":_vm.activePath,"router":true,"active-text-color":"#7861FF","collapse":_vm.isCollapse},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},_vm._l((_vm.routesList),function(item,index){return _c('div',{key:index},[(!item.children)?_c('div',{staticClass:"noChild"},[_c('el-menu-item',{attrs:{"index":item.index}},[_c('i',{staticClass:"picA1",style:({
              background: 'url(' + item.pic_a1 + ')' + ' ' + 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: '14px 14px',
              display: 'inline-block',
              width: '24px',
              height: '24px',
              verticalAlign: 'middle',
            })}),_c('i',{staticClass:"picA2",style:({
              background: 'url(' + item.pic_a2 + ')' + ' ' + 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: '14px 14px',
              display: 'inline-block',
              width: '24px',
              height: '24px',
              verticalAlign: 'middle',
            })}),_c('i',{staticClass:"picA3",style:({
              background: 'url(' + item.pic_a3 + ')' + ' ' + 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: '14px 14px',
              display: 'inline-block',
              width: '24px',
              height: '24px',
              verticalAlign: 'middle',
            })}),(!_vm.isCollapse)?_c('span',[_vm._v(_vm._s(item.name)+" "),(item.index == '/institutionsOption' && _vm.checkInfoStatus)?_c('i',{staticClass:"el-icon-warning",staticStyle:{"color":"red"}}):_vm._e()]):_vm._e()])],1):_c('div',{staticClass:"haveChild"},[_c('el-submenu',{attrs:{"index":item.index}},[_c('template',{slot:"title"},[_c('i',{staticClass:"picA1",style:({
                background: 'url(' + item.pic_a1 + ')' + ' ' + 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '14px 14px',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                verticalAlign: 'middle',
              })}),_c('i',{staticClass:"picA2",style:({
                background: 'url(' + item.pic_a2 + ')' + ' ' + 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '14px 14px',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                verticalAlign: 'middle',
              })}),_c('i',{staticClass:"picA3",style:({
                background: 'url(' + item.pic_a3 + ')' + ' ' + 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '14px 14px',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                verticalAlign: 'middle',
              })}),(!_vm.isCollapse)?_c('span',[_vm._v(_vm._s(item.name))]):_vm._e()]),_vm._l((item.children),function(_item,_index){return _c('div',{key:_index},[(_item.children && _item.children.length > 0)?_c('div',[_c('el-submenu',{attrs:{"index":_item.index}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_item.name))]),_vm._l((_item.children),function(_itemB,_indexB){return _c('el-menu-item',{key:_itemB.index,attrs:{"index":_itemB.index}},[_vm._v(_vm._s(_itemB.name))])})],2)],1):_c('div',[(_item.index=='/operationManual')?_c('el-menu-item',{attrs:{"index":_item.index},on:{"click":_vm.operationManual}},[_vm._v(_vm._s(_item.name))]):_c('el-menu-item',{attrs:{"index":_item.index}},[_vm._v(_vm._s(_item.name))])],1)])})],2)],1)])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }